import { COOKIE_MANAGEMENT_EVENT_ACTION, CookieBannerProps, COOKIE_PERMISSION } from '@cof/plastic-components';

import pushToDataLayer, { EVENTS } from './dataLayer/dataLayer';
import { EVENTS as NR_EVENTS, addNewRelicPageAction } from './newRelic';

type CookiePermissionsData = Parameters<CookieBannerProps['onCookieManagementEvent']>[1];

const doNewRelicActions = ({ data }: { data: CookiePermissionsData }): void => {
    if (!data || 'error' in data) return;

    if (data[COOKIE_PERMISSION.SITE_IMPROVEMENT]) {
        addNewRelicPageAction(NR_EVENTS.GDPR_PREF_ALLOWS_2);
    }
    if (data[COOKIE_PERMISSION.ADVERTISING]) {
        addNewRelicPageAction(NR_EVENTS.GDPR_PREF_ALLOWS_3);
    }
};

const doGtmActions = ({ data }: { data: CookiePermissionsData }): void => {
    // We send exactly one of GDPR_PREF_ALLOWS_2_3, GDPR_PREF_ALLOWS_2, GDPR_PREF_ALLOWS_3 to avoid overwrites
    if (!data || 'error' in data) return;

    if (data[COOKIE_PERMISSION.SITE_IMPROVEMENT] && data[COOKIE_PERMISSION.ADVERTISING]) {
        pushToDataLayer({ event: EVENTS.GDPR_PREF_ALLOWS_2_3 });
    } else if (data[COOKIE_PERMISSION.SITE_IMPROVEMENT]) {
        pushToDataLayer({ event: EVENTS.GDPR_PREF_ALLOWS_2 });
    } else if (data[COOKIE_PERMISSION.ADVERTISING]) {
        pushToDataLayer({ event: EVENTS.GDPR_PREF_ALLOWS_3 });
    }
};

/**
 * Called when the customer makes a decision on their cookie permissions
 *
 * @param {COOKIE_MANAGEMENT_EVENT_ACTION} action
 * @param {object} data
 */
const onCookieManagementEvent = (action: COOKIE_MANAGEMENT_EVENT_ACTION, data?: CookiePermissionsData): void => {
    const functions: Partial<Record<COOKIE_MANAGEMENT_EVENT_ACTION, () => void>> = {
        BANNER_INIT: () => addNewRelicPageAction(NR_EVENTS.GDPR_PREF_ALLOWS_1),
        BANNER_FIRST_RENDER: () => addNewRelicPageAction(NR_EVENTS.BANNER_OPEN),
        OPEN_COOKIE_MODAL: () => addNewRelicPageAction(NR_EVENTS.MODAL_OPEN),
        ACCEPT_ALL_COOKIES: () => addNewRelicPageAction(NR_EVENTS.GDPR_ACCEPT_ALL),
        REJECT_ALL_COOKIES: () => addNewRelicPageAction(NR_EVENTS.GDPR_REJECT_ALL),
        SET_COOKIE_PERMISSIONS: () => {
            doNewRelicActions({ data });
            doGtmActions({ data });
        }
    };
    functions[action]?.();
};

export default onCookieManagementEvent;
